import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { User, Boat, SailBase } from '../models/types';

interface PricingState {
    user: User | null;
    boat: Boat | null;
    sails: SailBase[];
    selectedOptions: Record<string, string[]>; // sailId -> optionIds
    selectedPackages: Record<string, string>; // sailId -> packageId
}

const initialState: PricingState = {
    user: null,
    boat: null,
    sails: [],
    selectedOptions: {},
    selectedPackages: {},
};

const pricingSlice = createSlice({
    name: 'pricing',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<User>) => {
            state.user = action.payload;
        },
        setBoat: (state, action: PayloadAction<Boat>) => {
            state.boat = action.payload;
        },
        addSail: (state, action: PayloadAction<SailBase>) => {
            state.sails.push(action.payload);
        },
        removeSail: (state, action: PayloadAction<string>) => {
            state.sails = state.sails.filter(sail => sail.id !== action.payload);
            delete state.selectedOptions[action.payload];
            delete state.selectedPackages[action.payload];
        },
        setOptions: (state, action: PayloadAction<{ sailId: string; optionIds: string[] }>) => {
            state.selectedOptions[action.payload.sailId] = action.payload.optionIds;
        },
        setPackage: (state, action: PayloadAction<{ sailId: string; packageId: string }>) => {
            state.selectedPackages[action.payload.sailId] = action.payload.packageId;
        },
    },
});

export const {
    setUser,
    setBoat,
    addSail,
    removeSail,
    setOptions,
    setPackage,
} = pricingSlice.actions;

export default pricingSlice.reducer;